<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.Constructions.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="txtConstructionsName"><small class="text-danger">*</small> {{$lang.Constructions.LabelName}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtConstructionsName"
                          :placeholder="$lang.Constructions.PlaceholderEnterName"
                          v-model="form.name.value"
                          :maxlength="form.name.maxlength"
                          :required="form.name.required"
                          :state="form.name.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtConstructionsName"><small class="text-danger">*</small> Código:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtConstructionsName"
                          :placeholder="'Código da Obra'"
                          v-model="form.code.value"
                          :maxlength="form.code.maxlength"
                          :required="form.code.required"
                          :state="form.code.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtConstructionsName"><small class="text-danger">*</small> Código Projeto:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtConstructionsName"
                          :placeholder="'Código da Projeto'"
                          v-model="form.codeProject.value"
                          :maxlength="form.codeProject.maxlength"
                          :required="form.codeProject.required"
                          :state="form.codeProject.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtConstructionsName"><small class="text-danger">*</small> Data de Criação:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtConstructionsName"
                          :placeholder="'____/____/_______'"
                          v-model="form.createDate.value"
                          :maxlength="form.createDate.maxlength"
                          :required="form.createDate.required"
                          :state="form.createDate.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtGroup"><small class="text-danger">*</small> Status:</label>
          <div class="input-group">
            <b-form-select v-model="form.companyID.value" :options="form.companyID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label for="txtGroup"><small class="text-danger">*</small> Empresa:</label>
          <div class="input-group">
            <b-form-select v-model="form.companyID.value" :options="form.companyID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtGroup"><small class="text-danger">*</small> Filial:</label>
          <div class="input-group">
            <b-form-select v-model="form.branchID.value" :options="form.branchID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtGroup"><small class="text-danger">*</small> Empreendimento:</label>
          <div class="input-group">
            <b-form-select v-model="form.developmentID.value" :options="form.developmentID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-2">
          <label for="txtConstructionsName"><small class="text-danger">*</small> CEP:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtConstructionsName"
                          :placeholder="'Digite o CEP'"
                          v-model="form.zipcode.value"
                          :maxlength="form.zipcode.maxlength"
                          :required="form.zipcode.required"
                          :state="form.zipcode.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtConstructionsName"><small class="text-danger">*</small> Endereço:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtConstructionsName"
                          :placeholder="'Digite o endereço'"
                          v-model="form.address.value"
                          :maxlength="form.address.maxlength"
                          :required="form.address.required"
                          :state="form.address.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtConstructionsName"><small class="text-danger">*</small> Número:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtConstructionsName"
                          :placeholder="'Digite o número'"
                          v-model="form.number.value"
                          :maxlength="form.number.maxlength"
                          :required="form.number.required"
                          :state="form.number.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtConstructionsName"><small class="text-danger">*</small> Complemento:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtConstructionsName"
                          :placeholder="'Digite o complemento'"
                          v-model="form.complement.value"
                          :maxlength="form.complement.maxlength"
                          :required="form.complement.required"
                          :state="form.complement.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtConstructionsName"><small class="text-danger">*</small> Bairro:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtConstructionsName"
                          :placeholder="'Digite o Bairro'"
                          v-model="form.district.value"
                          :maxlength="form.district.maxlength"
                          :required="form.district.required"
                          :state="form.district.state"></b-form-input>
          </div>
        </div>
       </div>
      <div class="form-group row pt-2">
        <div class="col-md-2">
          <label for="txtGroup"><small class="text-danger">*</small> Estado:</label>
          <div class="input-group">
            <b-form-select v-model="form.stateID.value" :options="form.stateID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtGroup"><small class="text-danger">*</small> Cidade (Código):</label>
          <div class="input-group">
            <b-form-select v-model="form.cityID.value" :options="form.cityID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtConstructionsName"><small class="text-danger">*</small> Cidade:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtConstructionsName"
                          :placeholder="'Digite a Cidade'"
                          v-model="form.city.value"
                          :maxlength="form.city.maxlength"
                          :required="form.city.required"
                          :state="form.city.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label for="txtDescription"> {{$lang.Constructions.LabelDescription}}:</label>
          <b-form-textarea id="txtDescription"
                      name="txtDescription"
                      v-model="form.description.value"
                      :placeholder="$lang.Constructions.PlaceholderEnterDescription"
                      :rows="form.description.rows"
                      :maxlength="form.description.maxlength"
                      :noResize="form.description.noResize"></b-form-textarea>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
    </Forms>

    <Tables ref="tableGrid"
            :columns="[$lang.Constructions.DataTable.Name,
              'Empresa',
              'Cidade',
              'Dt. de Criação',
              'Situação',
              $lang.Common.DataTable.Status,
              $lang.Common.DataTable.ActionDate,
              $lang.Common.DataTable.AccountAction,
              $lang.Common.DataTable.Actions]"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
        <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>

  </div>
</template>

<script>
import Constructions from './constructions.js'

export default Constructions
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/constructions/constructions.vue